import styled from '../../styles/styledComponents/themeComponents';

export const SearchTriggerStyle = styled.div`
  button {
    line-height: 33px;
  }
`;
